import React from 'react';
import LegalLayout from './LegalLayout';

const SECTIONS = [
  {
    title: '1. Controlador e encarregado',
    content: 'O LibbenIncorp atua como operador dos dados inseridos pelas incorporadoras clientes e como controlador dos dados de contato comercial e de navegacao do site. Em relacao aos dados dos compradores e colaboradores inseridos na plataforma, a incorporadora cliente e a controladora. Esta politica segue a Lei Geral de Protecao de Dados (LGPD, Lei 13.709/2018).'
  },
  {
    title: '2. Dados que coletamos',
    content: 'No site, coletamos dados de contato que voce informa (nome, e-mail, incorporadora, telefone) e dados de navegacao anonimizados. Na plataforma, tratamos os dados que a incorporadora cliente insere para operar o servico, como informacoes de empreendimentos, financeiro, obra, vendas e dados de clientes compradores.'
  },
  {
    title: '3. Finalidade do tratamento',
    content: 'Usamos os dados de contato para responder solicitacoes comerciais e de suporte. Os dados da plataforma sao tratados exclusivamente para prestar o servico contratado pela incorporadora: processar lancamentos, acompanhar obras, gerir vendas e disponibilizar o portal do cliente.'
  },
  {
    title: '4. Isolamento e seguranca',
    content: 'A arquitetura e multi-tenant com isolamento central: os dados de cada incorporadora sao escopados e nunca se misturam com os de outra. A infraestrutura e hospedada na AWS, com controle de acesso por perfil, criptografia em transito e backups regulares.'
  },
  {
    title: '5. Compartilhamento',
    content: 'Nao vendemos dados pessoais. Podemos compartilhar dados com provedores de infraestrutura e servicos essenciais a operacao (por exemplo, hospedagem e envio de e-mails), sempre sob obrigacoes de confidencialidade e seguranca compativeis com a LGPD.'
  },
  {
    title: '6. Direitos do titular',
    content: 'Voce pode solicitar confirmacao de tratamento, acesso, correcao, anonimizacao, portabilidade ou eliminacao dos seus dados, bem como revogar consentimentos. Para dados inseridos na plataforma por uma incorporadora, o pedido deve ser direcionado a ela, na qualidade de controladora.'
  },
  {
    title: '7. Retencao',
    content: 'Mantemos os dados pelo tempo necessario a prestacao do servico e ao cumprimento de obrigacoes legais e regulatorias. Apos o encerramento da contratacao, os dados sao disponibilizados para exportacao e posteriormente eliminados, salvo obrigacao legal de guarda.'
  },
  {
    title: '8. Contato',
    content: 'Para exercer seus direitos ou esclarecer duvidas sobre privacidade, utilize o e-mail de contato indicado abaixo.'
  }
];

export default function Privacy() {
  return (
    <LegalLayout
      title="Politica de Privacidade"
      canonical="https://www.libbenincorp.com/privacidade"
      metaDescription="Politica de Privacidade do LibbenIncorp e conformidade com a LGPD."
      updatedAt="15 de outubro de 2026"
      sections={SECTIONS}
    />
  );
}
